import { useQueries, useQuery } from '@tanstack/react-query';
import {
  featureFlagControllerAtMeQueryOptions,
  legacyPermissionsControllerAtMeQueryOptions,
} from 'korint-sdk';
import { useKorintProductConfig } from 'korint-sdk/react';
import { intersection } from 'lodash';

const GATED_PRODUCT_IDS = ['yeetVtc', 'axeceVtc', 'axeceMultiRisquesPro'];

export function useNewBusinessProductIds() {
  const { productsConfig, isLoading } = useKorintProductConfig();

  const { data: user } = useQuery(legacyPermissionsControllerAtMeQueryOptions());

  // The API rejects a productId from another tenant
  const gatedProductIds = GATED_PRODUCT_IDS.filter(productId => productId in productsConfig);
  const gatedFlags = useQueries({
    queries: gatedProductIds.map(productId => ({
      ...featureFlagControllerAtMeQueryOptions({ key: 'feat_accelerant_vtc_pricing', productId }),
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    })),
  });

  const productIds = user?.isSuperUser
    ? Object.keys(productsConfig)
    : intersection(user?.productIds, Object.keys(productsConfig));

  // Yeet/Axece new business stays closed until the flag is on for the product
  const closedProductIds = gatedProductIds.filter(
    (_, index) => gatedFlags[index]?.data?.enabled !== true,
  );

  return {
    productIds: productIds.filter(productId => !closedProductIds.includes(productId)),
    isLoading,
  };
}
